import React from "react";
import { groupBy, uniq } from "lodash";
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import { Box } from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import Skeleton from "@mui/material/Skeleton";

import { Colors } from "@/theme";
import { XLABELS } from "../../helper";
import { getLocalisationVal } from "@/utils/localizationUtil";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
    borderBottomColor: Colors.TABLE_HEADER1,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: Colors.TABLE_HEADER2,
  },
}));

const TableRowComponent = ({ localization, loading, dataForChart }) => {
  const localizationWithoutDecimal = {
    ...localization,
    currency_decimal: false,
  };

  const totalDays = dataForChart.xData;
  const daysByGroup = groupBy(totalDays);
  const dateLen = Object.keys(daysByGroup).length;
  const uniqueDays = XLABELS.slice(0, dateLen);

  const getRowData = ({ day, property, isPrice }) => {
    const lastChar = isPrice ? "p" : "L";
    const local = isPrice ? localization : localizationWithoutDecimal;
    const pointsOfDay = daysByGroup[day].length;
    const indexOf = totalDays.indexOf(day);
    const subArr = dataForChart[property].slice(indexOf, pointsOfDay + indexOf);
    const cellData = uniq(subArr)
      ?.map((val) => `${getLocalisationVal(local, val)}${lastChar}`)
      ?.join(", ");
    return cellData;
  };

  if (loading) {
    return (
      <TableBody>
        {Array.apply(null, Array(3))
          .map(function (y, i) {
            return i;
          })
          .map((id) => (
            <TableRow key={`skeleton-${id}`} sx={{ height: 80 }}>
              <StyledTableCell align="left">
                <Skeleton variant="rounded" width={"50%"} height={30} />
              </StyledTableCell>
              <StyledTableCell align="left">
                <Skeleton variant="rounded" width={"50%"} height={30} />
              </StyledTableCell>
              <StyledTableCell align="left">
                <Skeleton variant="rounded" width={"50%"} height={30} />
              </StyledTableCell>
              <StyledTableCell align="left">
                <Skeleton variant="rounded" width={"50%"} height={30} />
              </StyledTableCell>
              <StyledTableCell align="left">
                <Skeleton variant="rounded" width={"50%"} height={30} />
              </StyledTableCell>
            </TableRow>
          ))}
      </TableBody>
    );
  }

  return (
    <TableBody>
      {uniqueDays.map((day, id) => (
        <StyledTableRow key={`item-${id}`} sx={{ height: 80 }}>
          <StyledTableCell align="left">{day}</StyledTableCell>
          <StyledTableCell align="left">
            {getRowData({ day, property: "prices", isPrice: true })}
          </StyledTableCell>
          <StyledTableCell align="left">
            {getRowData({ day, property: "pricesToCompare", isPrice: true })}
          </StyledTableCell>
          <StyledTableCell align="left">
            {getRowData({ day, property: "volumes", isPrice: false })}
          </StyledTableCell>
          <StyledTableCell align="left">
            {getRowData({ day, property: "volumesToCompare", isPrice: false })}
          </StyledTableCell>
        </StyledTableRow>
      ))}
    </TableBody>
  );
};

export default TableRowComponent;
